import Menu from './components/Menu';
import Map from './components/Map';
import Carousel from './components/Carousel';
import FillForm from './components/FillForm';
import openModal from './components/openModal';

export class Alfred {
    constructor() {
        // Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
        Promise.all([Alfred.domReady()]).then(() => this.init());
    }


    init() {
        document.dispatchEvent(new Event('bless'));
        new Menu();

        const swiperCarousels = document.querySelectorAll('.swiper-container');
        if (swiperCarousels.length > 0) {
            swiperCarousels.forEach((carousel) => {
                new Carousel(carousel);
            });
        }

        new FillForm();
        new openModal();
    }

    static domReady() {
        return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
    }
}

new Alfred();

window.initMap = function initMap() {
    new Map();
};